import { render } from "./StudentPass.vue?vue&type=template&id=6fbfcb9b"
import script from "./StudentPass.vue?vue&type=script&lang=js"
export * from "./StudentPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__